import { render } from "./MostOrderedChart.vue?vue&type=template&id=3ddfb680&scoped=true"
import script from "./MostOrderedChart.vue?vue&type=script&lang=js"
export * from "./MostOrderedChart.vue?vue&type=script&lang=js"

import "./MostOrderedChart.vue?vue&type=style&index=0&id=3ddfb680&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddfb680"]])

export default __exports__